<template>
  <div>
    <span>
      <slot>{{ name }}</slot>
    </span>
    <label :class="{ active: audio, disabled: audioDisabled }">
      <i class="bx" :class="audio ? 'bxs-microphone' : 'bxs-microphone-off'" />
      <input
        type="checkbox"
        :checked="audio"
        hidden
        @change="$emit('update:audio', ($event.target as HTMLInputElement).checked)"
      />
    </label>
    <label :class="{ active: video, disabled: videoDisabled }">
      <i class="bx" :class="video ? 'bxs-video' : 'bxs-video-off'" />
      <input
        type="checkbox"
        :checked="video"
        hidden
        @change="$emit('update:video', ($event.target as HTMLInputElement).checked)"
      />
    </label>
    <!-- <ul
      v-if="showVideoDevices"
      class="contextmenu"
      style="top: 50px; left: 215px;"
    >
      <li
        v-for="device in videoDevices"
        :key="device.deviceId"
        :class="{active: device.deviceId === app.cameraDeviceId }"
        @click="selectVideo(device.deviceId)"
      >
        {{ device.label }}
      </li>
    </ul> -->
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { getApp } from '../models/App';

defineProps<{
  audio: boolean;
  video: boolean;
  audioDisabled?: boolean;
  videoDisabled?: boolean;
  devices?: { deviceId: string; label: string }[];
}>();

defineEmits<{
  (e: 'update:audio', value: boolean): void;
  (e: 'update:video', value: boolean): void;
}>();

const app = getApp();

const name = computed(() => app.connection.currentRoom?.getLocalUser()?.name ?? '...');
</script>

<style scoped>
div {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: white;
  align-items: stretch;
  position: relative;
}

div > span {
  flex-grow: 1;
  text-overflow: ellipsis;
  padding: 0 10px;
}

div > label {
  color: var(--color-gray-light);
  padding: 0 4px;
  font-size: 26px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

div > label:hover {
  outline: 1px solid white;
}

div > label.active {
  color: var(--color-black);
  background: var(--color-accent-icon);
}

div > label.disabled {
  pointer-events: none;
  color: var(--color-gray);
}
</style>
